module.exports = __webpack_public_path__ + "static/media/renko.32af0433.svg";